import React, { useState, useEffect } from 'react';
import { auth, database } from '../firebase';
import { ref, push, set } from 'firebase/database';

const HoldBill = () => {
  const [holdData, setHoldData] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Get hold data from localStorage
    const storedData = localStorage.getItem('holdBillData');
    if (storedData) {
      setHoldData(JSON.parse(storedData));
    }
  }, []);

  const handleSave = async () => {
    try {
      if (!auth.currentUser) {
        throw new Error('No user is logged in.');
      }

      const encodedEmail = auth.currentUser.email.replace(/[.#$[\]]/g, '_');
      const holdRef = ref(database, `users/${encodedEmail}/holdBills`);
      
      await push(holdRef, {
        ...holdData,
        userEmail: auth.currentUser.email,
        createdAt: new Date().toISOString(),
        status: 'held'
      });

      setMessage('Bill held successfully!');
      localStorage.removeItem('holdBillData');
      setTimeout(() => window.close(), 1500);
    } catch (error) {
      setMessage('Error holding bill: ' + error.message);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem('holdBillData');
    window.close();
  };

  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '1rem',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Arial, sans-serif',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1rem',
      backgroundColor: '#333',
      color: '#fff',
      marginBottom: '1rem',
    },
    title: {
      margin: 0,
      fontSize: '1.5rem',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '1rem',
      backgroundColor: '#fff',
    },
    th: {
      padding: '0.5rem',
      backgroundColor: '#00b7eb',
      color: '#fff',
      textAlign: 'left',
      border: '1px solid #ddd',
    },
    td: {
      padding: '0.5rem',
      border: '1px solid #ddd',
    },
    totalsBox: {
      backgroundColor: '#fff',
      padding: '1rem',
      border: '1px solid #ddd',
      borderRadius: '4px',
      marginBottom: '1rem',
    },
    totalsRow: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '0.5rem',
    },
    netAmountRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.5rem',
      backgroundColor: '#00b7eb',
      color: '#fff',
      borderRadius: '4px',
      fontWeight: 'bold',
    },
    buttonGroup: {
      display: 'flex',
      gap: '1rem',
      justifyContent: 'flex-end',
    },
    button: {
      padding: '0.5rem 1rem',
      borderRadius: '4px',
      fontSize: '1rem',
      cursor: 'pointer',
      border: 'none',
      color: '#fff',
    },
    saveButton: {
      backgroundColor: '#28a745',
    },
    cancelButton: {
      backgroundColor: '#dc3545',
    },
    message: {
      padding: '0.5rem',
      marginBottom: '1rem',
      backgroundColor: message.includes('Error') ? '#f8d7da' : '#d4edda',
      color: message.includes('Error') ? '#721c24' : '#155724',
      border: `1px solid ${message.includes('Error') ? '#f5c6cb' : '#c3e6cb'}`,
      borderRadius: '4px',
    },
  };

  if (!holdData) {
    return (
      <div style={styles.container}>
        <div style={styles.message}>No bill data found.</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {message && <div style={styles.message}>{message}</div>}
      <div style={styles.header}>
        <h1 style={styles.title}>Hold Bill - #{holdData.billNo}</h1>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>S.NO</th>
            <th style={styles.th}>ITEM DESCRIPTION</th>
            <th style={styles.th}>UNIT</th>
            <th style={styles.th}>QTY</th>
            <th style={styles.th}>DISC%</th>
            <th style={styles.th}>UNIT RATE</th>
            <th style={styles.th}>TAX</th>
            <th style={styles.th}>NET VALUE</th>
          </tr>
        </thead>
        <tbody>
          {holdData.items.map((item, index) => (
            <tr key={index}>
              <td style={styles.td}>{item.sNo}</td>
              <td style={styles.td}>{item.itemDescription}</td>
              <td style={styles.td}>{item.unit}</td>
              <td style={styles.td}>{item.qty}</td>
              <td style={styles.td}>{item.discPercent}</td>
              <td style={styles.td}>{item.unitRate}</td>
              <td style={styles.td}>{item.tax}</td>
              <td style={styles.td}>{item.netValue}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={styles.totalsBox}>
        <div style={styles.totalsRow}>
          <label>Bill No:</label>
          <span>{holdData.billNo}</span>
        </div>
        <div style={styles.totalsRow}>
          <label>Customer:</label>
          <span>{holdData.customer}</span>
        </div>
        <div style={styles.totalsRow}>
          <label>Phone:</label>
          <span>{holdData.phone}</span>
        </div>
        <div style={styles.totalsRow}>
          <label>Gross Amount:</label>
          <span>₹{holdData.totals.grossAmt.toFixed(2)}</span>
        </div>
        <div style={styles.totalsRow}>
          <label>Tax Amount:</label>
          <span>₹{holdData.totals.totalTax.toFixed(2)}</span>
        </div>
        <div style={styles.totalsRow}>
          <label>Discount:</label>
          <span>₹{holdData.totals.discount.toFixed(2)}</span>
        </div>
        <div style={styles.netAmountRow}>
          <label>Net Amount:</label>
          <span>₹{holdData.totals.netAmount.toFixed(2)}</span>
        </div>
      </div>

      <div style={styles.buttonGroup}>
        <button
          style={{ ...styles.button, ...styles.cancelButton }}
          onClick={handleCancel}
        >
          CANCEL
        </button>
        <button
          style={{ ...styles.button, ...styles.saveButton }}
          onClick={handleSave}
        >
          SAVE
        </button>
      </div>
    </div>
  );
};

export default HoldBill; 